import { NotSuitableForEvaluationReasonDto } from '../not-suitable-for-evaluation-reason-dto';

export class MarkAsNotSuitableForEvaluationRequestDto {
  assignmentId: number | null;
  evaluationId: number | null;
  reasonList: NotSuitableForEvaluationReasonDto[];
}
